export class PasswordGrantStruct {
    constructor(data) {
        this.grantType = "password";
        this.username = data.username;
        this.password = data.password;
    }
    static decode(data) {
        data.field("grant_type").equals("password");
        return new PasswordGrantStruct({
            username: data.field("username").string,
            password: data.field("password").string
        });
    }
    encode(context) {
        return {
            grant_type: this.grantType,
            username: this.username,
            password: this.password
        };
    }
}
//# sourceMappingURL=PasswordGrantStruct.js.map